import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getOverrideVariants, setAllOverrideVariants } from "Root/utils/experiment";
import { isDev } from "Root/utils/environment";
import { useEffect, useState } from "react";
const DebugMenu = () => {
    const [showOverrides, setShowOverrides] = useState(false);
    const [manualOverrides, setManualOverrides] = useState({});
    const [newKey, setNewKey] = useState("");
    const [newValue, setNewValue] = useState("");
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.metaKey && event.shiftKey && event.keyCode === 49 && isDev) {
                console.log("Debug window toggled!");
                setShowOverrides((prevState) => !prevState);
            }
        };
        const listener = document.addEventListener("keydown", handleKeyDown);
        setManualOverrides(getOverrideVariants());
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);
    const debugMenu = (_jsxs("div", { style: {
            position: "fixed",
            top: "90px",
            left: "24px",
            right: "24px",
            height: "300px",
            backgroundColor: "white",
            border: "1px solid black",
            padding: "16px",
            zIndex: "10000000",
        }, children: [_jsx("h2", { children: "Super secret debug menu" }), _jsx("hr", {}), _jsx("h3", { children: "AB test overrides" }), _jsx("table", { children: _jsxs("tbody", { children: [Object.keys(manualOverrides).map((x) => {
                            return (_jsxs("tr", { children: [_jsx("td", { children: x }), _jsxs("td", { children: [_jsx("input", { value: manualOverrides[x], onChange: (e) => {
                                                    const newManualOverrides = { ...manualOverrides };
                                                    newManualOverrides[x] = e.target.value;
                                                    setManualOverrides(newManualOverrides);
                                                } }), _jsx("button", { style: { marginLeft: "8px" }, onClick: () => {
                                                    const newManualOverrides = { ...manualOverrides };
                                                    delete newManualOverrides[x];
                                                    setManualOverrides(newManualOverrides);
                                                }, children: "x" })] })] }, x));
                        }), _jsxs("tr", { children: [_jsx("td", { children: _jsx("input", { placeholder: "test-name", value: newKey, onChange: (e) => setNewKey(e.target.value) }) }), _jsxs("td", { children: [_jsx("input", { placeholder: "variant", value: newValue, onChange: (e) => setNewValue(e.target.value) }), _jsx("button", { style: { marginLeft: "8px" }, onClick: () => {
                                                setManualOverrides({
                                                    ...manualOverrides,
                                                    [newKey]: newValue,
                                                });
                                                setNewKey("");
                                                setNewValue("");
                                            }, children: "+" })] })] })] }) }), _jsx("button", { style: { marginLeft: "4px", marginTop: "16px" }, onClick: () => {
                    setAllOverrideVariants(manualOverrides);
                }, children: "save changes" }), _jsx("hr", {})] }));
    return showOverrides ? debugMenu : null;
};
export default DebugMenu;
